export enum RequestTypes {
  GET_MULTIRT = 'getmultirt',
  GET_RECENT_HISTORY = 'getrecenthistory',
  GET_MARKETS = 'getmarkets'

}



// WEBPACK FOOTER //
// ./src/app/chart/request.types.ts